/* eslint-disable max-len */
import { useRef, useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions,
  Button, ButtonGroup, Menu, MenuItem, Box, Typography,
} from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

// Modos alternativos de encerramento (o modo padrão fica no botão destacado).
const ALT_MODES = [
  {
    key: 'winner-out',
    label: 'Sai time vencedor',
    description: 'Mantém contando uma vitória para eles, mantém time perdedor em quadra.',
    params: { winnerStays: false, loserStays: true, saveWinner: false },
  },
  {
    key: 'both-out',
    label: 'Sai ambos os times',
    description: 'Partida é encerrada e ambos os times são retirados da quadra, indo para o final da fila todos.',
    params: { winnerStays: false, loserStays: false, saveWinner: false },
  },
  {
    key: 'both-out-save',
    label: 'Sai ambos e salve o time vencedor',
    description: 'Nesse modo podemos utilizar a opção de recuperar time salvo depois.',
    params: { winnerStays: false, loserStays: false, saveWinner: true },
  },
];

const DEFAULT_MODE = { winnerStays: true, loserStays: false, saveWinner: false };

export function EndGameDialog({
  open, onClose, winnerName, onConfirm,
}) {
  const anchorRef = useRef(null);
  const [menuOpen, setMenuOpen] = useState(false);

  const handleSelectMode = (params) => {
    setMenuOpen(false);
    onConfirm(params);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Deseja encerrar este jogo?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          O time
          {' '}
          <strong>{winnerName}</strong>
          {' '}
          será declarado vencedor.
        </DialogContentText>

        <Button
          variant="contained"
          color="primary"
          size="large"
          fullWidth
          sx={{
            mt: 3, py: 1.5, fontWeight: 700, fontSize: '1.05rem',
          }}
          onClick={() => onConfirm(DEFAULT_MODE)}
        >
          Encerrar jogo
        </Button>

        <ButtonGroup ref={anchorRef} variant="outlined" fullWidth sx={{ mt: 1.5 }}>
          <Button
            sx={{ textTransform: 'none', justifyContent: 'flex-start' }}
            onClick={() => setMenuOpen(true)}
          >
            Selecione outro modo de encerramento
          </Button>
          <Button
            size="small"
            sx={{ flex: '0 0 auto', width: 40 }}
            aria-label="modos de encerramento"
            onClick={() => setMenuOpen(true)}
          >
            <ArrowDropDownIcon />
          </Button>
        </ButtonGroup>

        <Menu
          anchorEl={anchorRef.current}
          open={menuOpen}
          onClose={() => setMenuOpen(false)}
          slotProps={{ paper: { sx: { maxWidth: 360 } } }}
        >
          {ALT_MODES.map((mode) => (
            <MenuItem
              key={mode.key}
              onClick={() => handleSelectMode(mode.params)}
              sx={{ whiteSpace: 'normal', alignItems: 'flex-start', py: 1.25 }}
            >
              <Box>
                <Typography variant="body1" fontWeight={600}>{mode.label}</Typography>
                <Typography variant="body2" color="text.secondary">{mode.description}</Typography>
              </Box>
            </MenuItem>
          ))}
        </Menu>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">Cancelar</Button>
      </DialogActions>
    </Dialog>
  );
}
